var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "score-tip-popper"
  }, [_c('table', {
    staticClass: "tips-pop-table",
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0",
      "border": "0"
    }
  }, [_c('div', {
    staticClass: "tip-head"
  }, [_c('thead', [(_vm.queryType === '1' || _vm.queryType === '2' || _vm.queryType === '3' || _vm.queryType === '') ? _c('tr', [_vm._m(0), _c('th', {
    attrs: {
      "width": "130"
    }
  }, [_vm._v("参考问题")]), _c('th', {
    attrs: {
      "width": "240"
    }
  }, [_vm._v("S")]), _c('th', {
    attrs: {
      "width": "150"
    }
  }, [_vm._v("A")]), _c('th', {
    attrs: {
      "width": "150"
    }
  }, [_vm._v("B")]), _c('th', {
    attrs: {
      "width": "150"
    }
  }, [_vm._v("C")]), _c('th', {
    attrs: {
      "width": "100"
    }
  }, [_vm._v("D")]), _c('th', {
    attrs: {
      "width": "41"
    }
  }, [_vm._v("评分")])]) : _vm._e(), _vm._v(" "), (_vm.queryType === '4' || _vm.queryType === '5') ? _c('tr', [_vm._m(1), _c('th', {
    attrs: {
      "width": "130"
    }
  }, [_vm._v("参考问题")]), _vm._m(2), _vm._m(3), _vm._m(4), _vm._m(5), _vm._m(6), _c('th', {
    attrs: {
      "width": "41"
    }
  }, [_vm._v("评分")])]) : _vm._e(), _vm._v(" "), (_vm.queryType === '8') ? _c('tr', [_vm._m(7), _c('th', {
    attrs: {
      "width": "160"
    }
  }, [_vm._v("参考问题")]), _vm._m(8), _vm._m(9), _vm._m(10), _vm._m(11), _vm._m(12), _c('th', {
    attrs: {
      "width": "31"
    }
  }, [_vm._v("评分")])]) : _vm._e(), _vm._v(" "), (_vm.queryType === '7') ? _c('tr', [_vm._m(13), _c('th', {
    attrs: {
      "width": "248"
    }
  }, [_vm._v("S[9,10]")]), _c('th', {
    attrs: {
      "width": "208"
    }
  }, [_vm._v("A[7,9)")]), _c('th', {
    attrs: {
      "width": "187"
    }
  }, [_vm._v("B[4-7)")]), _c('th', {
    attrs: {
      "width": "299"
    }
  }, [_vm._v("C[0-4)")]), _c('th', {
    attrs: {
      "width": "41"
    }
  }, [_vm._v("评分")])]) : _vm._e(), _vm._v(" "), (_vm.queryType === '14') ? _c('tr', [_c('th', {
    attrs: {
      "width": "112"
    }
  }, [_vm._v("考察维度")]), _c('th', {
    attrs: {
      "width": "250"
    }
  }, [_vm._v("考察点")]), _c('th', {
    attrs: {
      "width": "100"
    }
  }, [_vm._v("分数（5分制）")]), _c('th', {
    attrs: {
      "width": "678"
    }
  }, [_vm._v("分数定义")])]) : _vm._e(), _vm._v(" "), (_vm.queryType === '15') ? _c('tr', [_c('th', {
    attrs: {
      "width": "134"
    }
  }, [_vm._v("考察维度")]), _c('th', {
    attrs: {
      "width": "258"
    }
  }, [_vm._v("考察点")]), _c('th', {
    attrs: {
      "width": "100"
    }
  }, [_vm._v("分数（5分制）")]), _c('th', {
    attrs: {
      "width": "678"
    }
  }, [_vm._v("分数定义")])]) : _vm._e(), _vm._v(" "), (_vm.queryType === '16') ? _c('tr', [_c('th', {
    attrs: {
      "width": "114"
    }
  }, [_vm._v("考察维度")]), _c('th', {
    attrs: {
      "width": "250"
    }
  }, [_vm._v("考察点")]), _c('th', {
    attrs: {
      "width": "100"
    }
  }, [_vm._v("分数（5分制）")]), _c('th', {
    attrs: {
      "width": "680"
    }
  }, [_vm._v("分数定义")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tip-body"
  }, [(_vm.queryType === '1' || _vm.queryType === '2' || _vm.queryType === '3' || _vm.queryType === '') ? _c('tester-detail') : (_vm.queryType === '4') ? _c('gzRecruitment2020Detail') : (_vm.queryType === '5' && _vm.queryTurn === '0') ? _c('hzRecruitment2020DetailFirst') : (_vm.queryType === '5' && _vm.queryTurn !== '0') ? _c('hzRecruitment2020DetailSecond') : (_vm.queryType === '9') ? _c('gzRecruitment2021Detail') : (_vm.queryType === '10' && _vm.queryTurn === '0') ? _c('hzRecruitment2021DetailFirst') : (_vm.queryType === '10' && _vm.queryTurn !== '0') ? _c('hzRecruitment2021DetailSecond') : (_vm.queryType === '7') ? _c('social-qa') : (_vm.queryType === '8') ? _c('verify-qa') : (_vm.queryType === '14') ? _c('gametest-detail') : (_vm.queryType === '15') ? _c('softwaretestdev-deatail') : (_vm.queryType === '16') ? _c('softwaretest-deatail') : (_vm.queryType === '17' && _vm.queryTurn === '0') ? _c('hzShRecruitment2022DetailFirst') : (_vm.queryType === '17' && _vm.queryTurn !== '0') ? _c('hzShRecruitment2022DetailSecond') : (_vm.queryType === '18') ? _c('gzGameTest2022Detail') : (_vm.queryType === '19') ? _c('gzSoftWaretest2022Detail') : (_vm.queryType === '20') ? _c('gzSoftWaretestdev2022Detail') : (_vm.queryType === '21' && _vm.queryTurn === '0') ? _c('hzShSoftGametest2022DetailFirst') : (_vm.queryType === '21' && _vm.queryTurn !== '0') ? _c('hzShSoftGametest2022DetailSecond') : (_vm.queryType === '22' && _vm.queryTurn === '0') ? _c('hzShSoftWaretest2022DetailFirst') : (_vm.queryType === '22' && _vm.queryTurn !== '0') ? _c('hzShSoftWaretest2022DetailSecond') : (_vm.queryType === '23' && _vm.queryTurn === '0') ? _c('hzShSoftGametestdev2022DetailFirst') : (_vm.queryType === '23' && _vm.queryTurn !== '0') ? _c('hzShSoftGametestdev2022DetailSecond') : (_vm.queryType === '24' && _vm.queryTurn === '0') ? _c('lqa2022DetailFirst') : (_vm.queryType === '24' && _vm.queryTurn !== '0') ? _c('lqa2022DetailSecond') : _vm._e()], 1)])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "colspan": "2",
      "width": "91"
    }
  }, [_vm._v("评分参考"), _c('br'), _vm._v("标准：")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "colspan": "2",
      "width": "91"
    }
  }, [_vm._v("评分参考"), _c('br'), _vm._v("标准：")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "width": "240"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("S")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "width": "150"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_vm._v("A")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "width": "150"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("B")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "width": "150"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("C")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "width": "100"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("D")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "colspan": "2",
      "width": "100"
    }
  }, [_vm._v("评分参考"), _c('br'), _vm._v("标准：")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "width": "160"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("S")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "width": "160"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_vm._v("A")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "width": "150"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("B")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "width": "150"
    }
  }, [_c('span', {
    staticClass: "green"
  }, [_vm._v("C")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "width": "150"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("D")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "colspan": "2",
      "width": "91"
    }
  }, [_vm._v("评分参考"), _c('br'), _vm._v("标准：")])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f85923c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/evaluation/score-tips/score-tips.vue
// module id = null
// module chunks = 